module.exports = __webpack_public_path__ + "static/media/27.daac4196.webp";